module.exports = __webpack_public_path__ + "svgs/video-empty.e7d50d53.svg";